import axios from 'axios';
import config from '../config/sbf_config';

let instanceIdentityApi;

export const identityServiceApi = async (params) => {
    const key = config.featureToggles.globalAuth ? 'token' : 'jwtToken';
    const jwtToken = localStorage.getItem(key);

    if (!instanceIdentityApi) {
        instanceIdentityApi = axios.create({
            baseURL: `${config.identityServiceUrl}/api/v1/`,
        });
    }

    return instanceIdentityApi({
        ...params,
        headers: {
            Authorization: `Bearer ${jwtToken}`,
        },
    });
};



// WEBPACK FOOTER //
// ./src/infra/identityApi.service.js